<h1 *ngIf="IsCreation" mat-dialog-title class="p-2 text-center">Ajout d'un utilisateur </h1>
<h1 *ngIf="!IsCreation" mat-dialog-title class="p-2 text-center">Modification d'un utilisateur </h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="Model.Email" placeholder="Email" [formControl]="ValidEmail" [disabled]="!IsCreation" required>
            <mat-error *ngIf="!ValidEmail.valid">
                Email incorrect
            </mat-error>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="Model.FirstName" placeholder="Prénom" required>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="Model.LastName" placeholder="Nom" required>
        </mat-form-field>
    </div>

    
    
   


    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()">
            <span *ngIf="IsCreation">Ajouter</span>
            <span *ngIf="!IsCreation">Modifier</span>
        </button>
    </div>
</div>